import { Tooltip, TooltipProps, TypographyProps } from '@mui/material';
import { FC } from 'react';
import { CellText } from './styled';

interface TableTextProps {
	text: string;
	TypoProps?: TypographyProps;
	ToolProps?: TooltipProps;
}

export const TableText: FC<TableTextProps> = ({ text, ToolProps, TypoProps }) => (
	<Tooltip title={text} {...ToolProps}>
		{/* data-self-tooltip: CellOverflowTooltip nu mai adaugă un al doilea tooltip. */}
		<CellText data-self-tooltip="" {...TypoProps}>
			{text}
		</CellText>
	</Tooltip>
);

TableText.defaultProps = {
	ToolProps: undefined,
	TypoProps: undefined
};
